<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>圈层申请列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-input size="small" v-model="userName" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="status" placeholder="请选择审核状态">
                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="circlesId" placeholder="请选择圈层名称">
                    <el-option v-for="item in options1" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="DataList" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" sortable prop="userName" label="用户名" width="160"></el-table-column>
            <el-table-column align="center" sortable prop="circlesName" label="圈层名" width="160"></el-table-column>
            <el-table-column align="center" prop="status" label="审核状态" width="120"
                :formatter="Status"></el-table-column>
            <el-table-column align="center" sortable prop="content" label="内容" width="160"></el-table-column>
            <el-table-column align="center" sortable prop="url" label="图片" width="160">
                <template slot-scope="scope">
                    <div v-if="scope.row.url">
                        <el-image v-for="(image, index) in scope.row.url.split(',')" :key="index" :src="image"
                            style="margin-right: 5px; width: 80px;" :preview-src-list="[image]"></el-image>
                    </div>
                    <div v-else>没有图片</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="ShenheYes(scope.row)"
                        v-if="scope.row.status === 0">审核通过</el-button>
                    <el-button size="mini" type="danger" @click="ShenheNo(scope.row)"
                        v-if="scope.row.status === 0">审核不通过</el-button>
                    <el-button size="mini" type="info" disabled v-if="scope.row.status === 1">已审核</el-button>
                    <el-button size="mini" type="info" disabled v-if="scope.row.status === 2">已审核</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
import {
    getApplyCirclesList,
    aduitApplyCircles,
    getCirclesList
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            DataList: [],
            loading: false,
            userName: '',
            status: '',
            circlesId: '',
            options: [{
                value: 0,
                label: '待审核'
            }, {
                value: 1,
                label: '审核通过'
            }, {
                value: 2,
                label: '审核不通过'
            }],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            options1: []
        }
    },
    created() {
        this.getdata(1)
        this.getCircles()
    },
    // 注册组件
    components: {
        Pagination
    },
    methods: {
        // 获取圈层列表
        getCircles() {
            getCirclesList().then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg,
                    });
                } else {
                    res.data.list.forEach((item) => {
                        this.options1.push({ label: item.name, value: item.id })
                    })
                    return;
                }
            })
        },
        // 搜索数据
        search() {
            this.getdata(1)
        },
        // 重置数据
        chongzhi() {
            this.userName = ''
            this.status = ''
            this.circlesId = ''
            this.getdata(1)
        },
        // 状态
        Status: function (row) {
            if (row.status == 0) {
                return "待审核"
            } else if (row.status == 1) {
                return "审核通过"
            } else if (row.status == 2) {
                return "审核不通过"
            }
        },
        // 审核通过
        ShenheYes(row) {
            this.$confirm("确定通过吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "success",
            }).then(() => {
                let data = {
                    id: row.id,
                    status: 1
                }
                aduitApplyCircles(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getdata(this.pageparm.currentPage)
                    } else {
                        this.$message.error(res.msg)
                    }
                })

            }).catch((err) => {
                this.$message({
                    type: "info",
                    message: "已取消通过",
                });
            });
        },
        // 审核不通过
        ShenheNo(row) {
            this.$confirm("确定不通过吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            }).then(() => {
                let data = {
                    id: row.id,
                    status: 2
                }
                aduitApplyCircles(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getdata(this.pageparm.currentPage)
                    } else {
                        this.$message.error(res.msg)
                    }
                })

            }).catch((err) => {
                this.$message({
                    type: "info",
                    message: "已取消不通过",
                });
            });
        },
        // 分页插件事件
        callFather(parm) {
            this.pageparm.page = parm.currentPage
            this.getdata(parm.currentPage)
        },
        // 获取数据
        getdata(page) {
            this.loading = true;
            getApplyCirclesList({
                page: (page - 1) * 20,
                status: this.status,
                userName: this.userName,
                circlesId: this.circlesId
            }).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.DataList = res.data.list;
                    this.pageparm.currentPage = page;
                    this.pageparm.total = res.data.count;
                    return;
                } else {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    })
                }
            })
        }
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/circles/Examine.vue